export const formatTickerToURLFriendly = (ticker: string): string => {
  if (!ticker) return '';
  return ticker.replace('/', '-');
};

export const formatTickerInURLToTicker = (ticker: string): string => {
  if (!ticker) return '';
  const cleanedTicker = ticker.replace(/[^a-zA-Z0-9-/.]/g, '');
  return formatTickerToUppercase(cleanedTicker).replace('-', '/');
};

/**
 * Crypto/forex symbols in the news backend use a $ prefix (e.g. $DOGE, $BTC), not DOGE-USD or DOGE/USD.
 * Converts XXX-USD or XXX/USD to $XXX; other symbols returned unchanged.
 */
export const formatSymbolToCashSymbol = (symbol: string): string => {
  if (!symbol || typeof symbol !== 'string') return symbol;
  if (symbol.startsWith('$')) return symbol;
  const upper = symbol.toUpperCase();
  if (upper.endsWith('-USD')) return `$${upper.slice(0, -4)}`;
  if (upper.includes('/USD')) return `$${upper.split('/')[0]}`;
  return symbol;
};

export const formatTickerToUppercase = (ticker: string): string => {
  if (!ticker) return '';
  const areAllLettersLowercase = ticker.split('').every(letter => letter === letter.toLowerCase());
  const result = areAllLettersLowercase ? ticker.toUpperCase() : ticker;
  if (ticker.includes('-')) {
    return ticker.toUpperCase();
  }
  return result;
};

const CRYPTO_SUFFIXES_TO_STRIP = [' - United States dollar', ' - USD', ' – United States dollar', ' – USD'];

export function formatSymbolDisplayName(name: string | null | undefined): string {
  if (!name || typeof name !== 'string') return '';
  let out = name.trim();
  for (const suffix of CRYPTO_SUFFIXES_TO_STRIP) {
    if (out.endsWith(suffix)) {
      out = out.slice(0, -suffix.length).trim();
      break;
    }
  }
  return out;
}
